import { Link, Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';
import { useAppSelector } from 'store/store';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  url?: string;
}

const Breadcrumbs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const currentContext = useAppSelector((state) => state.contextData.context) || 'LAB';
  const friendlyId = useAppSelector((state) => state.contextData.friendlyId) || null;

  const urlSegments = pathname
    .replace('/tenant', '')
    .replace('/view', '')
    .split('/')
    .filter((path) => !['', 'home'].includes(path));

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: t(`context.${currentContext}` as any),
      url: '/tenant/home' // Rotta base del tenant
    }
  ];

  urlSegments.forEach((segment, index) => {
    const fullRoute = `/tenant/${urlSegments.slice(0, index + 1).join('/')}`;

    const isLastSegment = index === urlSegments.length - 1;

    const fallbackKey = `global.${segment}` as any;
    const menuKey = `menu.${segment}` as any;

    const translation = t(menuKey, { defaultValue: t(fallbackKey) as string }) as string;

    const labelTranslation = isLastSegment ? friendlyId || translation : translation;

    breadcrumbItems.push({
      label: labelTranslation,
      url: isLastSegment ? undefined : fullRoute
    });
  });

  if (urlSegments.length === 0) return null;

  return (
    <MUIBreadcrumbs
      separator=">"
      aria-label="breadcrumb"
      sx={{
        '& .MuiBreadcrumbs-li, & .MuiBreadcrumbs-li *': {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          fontStyle: 'normal',
          lineHeight: '140%',
          letterSpacing: '0%',
          color: '#727272'
        },

        '& .MuiBreadcrumbs-separator': {
          color: '#727272',
          mx: 1.5,
          fontWeight: 400,
          fontSize: '14px'
        }
      }}>
      {breadcrumbItems.map((item, index) => {
        const isLastItem = index === breadcrumbItems.length - 1;

        return isLastItem ? (
          <Typography
            key={`${item.label}-${index}`}
            className="text-[#1c1f23] font-medium select-none">
            {item.label}
          </Typography>
        ) : (
          <Link
            key={`${item.label}-${index}`}
            underline="none"
            className="cursor-pointer transition-colors hover:text-slate-900"
            onClick={() => item.url && navigate(item.url)}>
            {item.label}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
